import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

// Material
import { makeStyles } from "@material-ui/core/styles";
import CardActionArea from "@material-ui/core/CardActionArea";

// Icons
import chevron from "../../assets/icons/chevron.svg";
import pendingStatementIcon from "../../assets/icons/pendingStatementIcon.svg";

// Config
import colors from "../../config/colors";
import styles from "../../config/styles";

// Components
import Text from "../Text";
import RequiredChip from "../ActionRequiredChip/RequiredChip";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    borderBottom: ({ isLast }) => !isLast && styles.values.border,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: colors.cloudBurst,
    gap: theme.spacing(2),
    borderLeft: ({ actionRequired }) => actionRequired && "5px solid #885067"
  },
  selected: {
    backgroundColor: colors.lilyWhite,
    pointerEvents: "none"
  },
  chevron: {
    transform: "rotate(90deg)"
  },
  text: {
    marginRight: "auto",
    color: ({ actionRequired }) => actionRequired && colors.lockedCardText
  },
  iconPending: {
    width: "24px"
  }
}));

const LinkItem = ({ to, text, isLast, actionRequired }) => {
  const classes = useStyles({ isLast, actionRequired });

  return (
    <CardActionArea
      component={NavLink}
      to={to}
      activeClassName={classes.selected}
      className={classes.root}
    >
      {actionRequired && (
        <img
          src={pendingStatementIcon}
          alt=""
          className={classes.iconPending}
        />
      )}
      <Text type="subtitle2" className={classes.text}>
        {text}
      </Text>
      {actionRequired && <RequiredChip />}
      <img src={chevron} alt="" className={classes.chevron} />
    </CardActionArea>
  );
};

LinkItem.propTypes = {
  isLast: PropTypes.bool,
  actionRequired: PropTypes.bool,
  text: PropTypes.string,
  to: PropTypes.string.isRequired
};

LinkItem.defaultProps = {
  isLast: false,
  text: "",
  actionRequired: false
};

export default LinkItem;
